import PropTypes from 'prop-types';
import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu
} from "reactstrap";
import { Link } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { fetchDashboardData } from "../../store/dashboard/actions";

// Custom Scrollbar
import SimpleBar from "simplebar-react";

// import images
import servicesIcon1 from "../../assets/images/services-icon/01.png";
import servicesIcon2 from "../../assets/images/services-icon/02.png";
import servicesIcon3 from "../../assets/images/services-icon/wallet.png";
import servicesIcon4 from "../../assets/images/services-icon/vehicles.png";
import user2 from "../../assets/images/users/user-2.jpg";
import user3 from "../../assets/images/users/user-3.jpg";
import user4 from "../../assets/images/users/user-4.jpg";
import user5 from "../../assets/images/users/user-5.jpg";
import user6 from "../../assets/images/users/user-6.jpg";
import smimg1 from "../../assets/images/small/img-1.jpg";
import smimg2 from "../../assets/images/small/img-2.jpg";

// Charts
import LineAreaChart from "../AllCharts/apex/lineareachart";
import RadialChart from "../AllCharts/apex/apexdonut";
import Apexdonut from "../AllCharts/apex/apexdonut1";
import SparkLine from "../AllCharts/sparkline/sparkline";
import SparkLine1 from "../AllCharts/sparkline/sparkline1";
import Salesdonut from "../AllCharts/apex/salesdonut";


//i18n
import { withTranslation } from "react-i18next";
import DateRangeLabel from 'components/Common/DateTime';

const Dashboard = props => {
  const dispatch = useDispatch();

  const { data, loading, error } = useSelector(state => state.Dashboard);

  useEffect(() => {
    dispatch(fetchDashboardData());
  }, [dispatch]);

  const getPercentage = (part, total) => {
    if (!part || !total || total === 0) return 0;
    return Math.round((part / total) * 100);
  };

  const complete = data?.data?.total_booking_complete || 0;
  const cancel = data?.data?.total_booking_cancel || 0;
  const expired = data?.data?.total_booking_expired || 0;

  const total = complete + cancel + expired;

  const percent = (val) => {
    if (total === 0) return '0.0%';
    return ((val / total) * 100).toFixed(1) + '%';
  };

  const [menu, setMenu] = useState(false);
  const toggle = () => {
    setMenu(!menu);
  };
  document.title = "Dashboard | Sawari Online";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Dashboard</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">Welcome to Sawari Online Dashboard</li>
                </ol>
              </Col>
            </Row>
          </div>
          <Row>
            <Col xl={3} md={6}>
              <Card className="mini-stat text-white" style={{ backgroundColor: '#6B0729' }}>
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon1} alt="" />
                    </div>
                    <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                      Bookings
                    </h5>
                    <h4 className='fw-medium font-size-18'>
                      {data?.data?.total_booking ?? 0}
                      {/* <i className="mdi mdi-arrow-up text-success ms-2"></i> */}
                    </h4>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3} md={6}>
              <Card className="mini-stat text-white" style={{ backgroundColor: '#6B0729' }}>
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon2} alt="" />
                    </div>
                    <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                      Revenue
                    </h5>
                    <h4 className='fw-medium font-size-18'>
                      LYD {data?.data?.total_revenue ?? 0}
                      {/* <i className="mdi mdi-arrow-down text-danger ms-2"></i> */}
                    </h4>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3} md={6}>
              <Card className="mini-stat text-white" style={{ backgroundColor: '#6B0729' }}>
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon3} alt="" />
                    </div>
                    <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                      Wallet
                    </h5>
                    <h4 className='fw-medium font-size-18'>
                      LYD {data?.data?.balanced_amount ?? 0}
                    </h4>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3} md={6}>
              <Card className="mini-stat text-white" style={{ backgroundColor: '#6B0729' }}>
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon4} alt="" />
                    </div>
                    <h5 className="font-size-16 text-uppercase mt-0 text-white-50">
                      Vehicles
                    </h5>
                    <h4 className='fw-medium font-size-18'>
                      {data?.data?.active_vehicles ?? 0}
                    </h4>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col xl={9}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Monthly Earning</h4>
                  <Row>
                    <Col lg={7}>
                      <div>
                        <LineAreaChart chartData={data?.data?.monthly_bookings || []} />
                      </div>
                    </Col>
                    <Col lg={5}>
                      <Row>
                        <Col md={6}>
                          <div className="text-center">
                            <p className="text-muted mb-4">This month</p>
                            <h3 className='font-size-18'>LYD {data?.data?.current_month_amount}</h3>
                            <p className="text-muted mb-4">
                              Total revenue generated in the current month.
                            </p>
                            <RadialChart value={getPercentage(data?.data?.current_month_amount, data?.data?.total_revenue)} />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="text-center">
                            <p className="text-muted mb-4">Last month</p>
                            <h3 className='font-size-18'>LYD {data?.data?.last_month_amount}</h3>
                            <p className="text-muted mb-4">
                              Total revenue generated in the previous month.
                            </p>
                            <Apexdonut value={getPercentage(data?.data?.last_month_amount, data?.data?.total_revenue)} />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>

            <Col xl={3}>
              <Card>
                <CardBody>
                  <div>
                    <h4 className="card-title mb-4">Drivers Analytics</h4>
                  </div>
                  <div className="wid-peity mb-4">
                    <div className="row">
                      <div className="col-md-6">
                        <div>
                          <p className="text-muted">Online Drivers</p>
                          <h5 className="mb-4">{data?.data?.online_drivers ?? 0}</h5>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-4"> 
                          <SparkLine value={data?.data?.online_driver_activity_24h} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="wid-peity mb-4">
                    <div className="row">
                      <div className="col-md-6">
                        <div>
                          <p className="text-muted">Offline Drivers</p>
                          <h5 className="mb-4">{data?.data?.offline_drivers ?? 0}</h5>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-4">
                          <SparkLine value={data?.data?.offline_driver_activity_24h} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="">
                    <div className="row">
                      <div className="col-md-6">
                        <div>
                          <p className="text-muted">Total Drivers</p>
                          <h5>{data?.data?.total_drivers ?? 0}</h5>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-4">
                          <SparkLine value={data?.data?.total_driver_activity_24h} />
                        </div>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col xl={4}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Bookings Report</h4>
                  <div className="cleafix">
                    <p className="float-start">
                      <i className="mdi mdi-calendar me-1 text-primary"></i> <DateRangeLabel />
                    </p>
                    <h5 className="font-18 text-end">LYD {data?.data?.total_bookings_amount.toFixed(2)}</h5>
                  </div>
                  <div id="ct-donut" className="ct-chart wid pt-4">
                    <Salesdonut value={data?.data} />
                  </div>
                  <div className="mt-4">
                    <table className="table mb-0">
                      <tbody>
                        <tr>
                          <td>
                            <span className="badge bg-primary">CMP</span>
                          </td>
                          <td>Complete</td>
                          <td className="text-end">{percent(complete)}</td>
                        </tr>
                        <tr>
                          <td>
                            <span className="badge bg-success">CND</span>
                          </td>
                          <td>Canceled</td>
                          <td className="text-end">{percent(cancel)}</td>
                        </tr>
                        <tr>
                          <td>
                            <span className="badge bg-warning">EXP</span>
                          </td>
                          <td>Expired</td>
                          <td className="text-end">{percent(expired)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={8}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Latest Transactions</h4>
                  <div className="table-responsive">
                    <table className="table table-hover table-centered table-nowrap mb-0">
                      <thead>
                        <tr>
                          <th scope="col">(#) ID</th>
                          <th scope="col">Purpose</th>
                          <th scope="col">Type</th>
                          <th scope="col">Date</th>
                          <th scope="col">Amount</th>
                          <th scope="col">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.data?.transactions?.length > 0 ? (
                          data?.data?.transactions.map((txn) => (
                            <tr key={txn.id}>
                              <th scope="row">#{txn.id}</th>
                              <td>{txn.purpose}</td>
                              <td>{txn.type}</td>
                              <td>{new Date(txn.created_at).toLocaleDateString()}</td>
                              <td>LYD {parseFloat(txn.amount).toFixed(2)}</td>
                              <td>
                                <span
                                  className={`badge ${
                                    txn.status === "success"
                                      ? "bg-success"
                                      : txn.status === "pending"
                                      ? "bg-warning"
                                      : "bg-danger"
                                  }`}
                                >
                                  {txn.status}
                                </span>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" className="text-center">
                              No transactions found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any
};

// export default withTranslation()(Dashboard);
export default Dashboard;
